import React from "react";
import tick_icon from './images/tick-icon.png';
import business_women_img from './images/Business-woman-girl.png';
import ScrollAnimation from 'react-animate-on-scroll';


export default function Offshore() {


    return (
        <>

            <div className='container-fluid bg-img-offshore main-Offshore ' id="offshore">
                <section className="mx-auto max-w-screen-xl pb-12 px-4 items-center lg:flex md:px-8">
                    <div className="space-y-4 flex-1 sm:text-center lg:text-left" >
                        <ScrollAnimation animateIn="fadeIn">
                            <h1 className="text-white font-bold text-4xl">
                                Offshore Company Formation In <br></br> <span style={{ color: "#eab308" }}>Dubai, UAE</span>
                            </h1>
                        </ScrollAnimation>

                    </div>
                </section>
            </div>

            <section className="py-14">
                <div className="max-w-screen-xl mx-auto md:px-8">
                    <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex">
                        <div className="flex-1 sm:hidden lg:block">
                            <ScrollAnimation animateIn="fadeInLeft">
                                <img src="https://www.companysetup.ae/wp-content/uploads/2019/12/uae-mainland-company.jpg" className="md:max-w-lg sm:rounded-lg" alt="" />
                            </ScrollAnimation>
                        </div>
                        <div className="max-w-xl px-4 space-y-3 mt-6 sm:px-0 md:mt-0 lg:max-w-2xl">
                            <ScrollAnimation animateIn="fadeIn">
                                <p className="text-gray-600 text-3xl font-bold sm:text-3xl">
                                    Offshore Company Registration in Dubai
                                </p>
                                <p className="mt-3  text-gray-500 font-small">
                                    Unique features of offshore company formation in Dubai, UAE
                                </p>
                                <p className="text-gray-600 text-3xl font-bold sm:text-3xl" style={{ marginTop: 30 }}>
                                    <span style={{ color: "#eab308" }}>Scope and scale</span>
                                </p>
                                <p className="mt-3  text-gray-500 font-small">
                                    A company can be established offshore, that is away from the UAE mainland and not in a free zone.
                                    You could establish an offshore company in RAK Offshore (officially the Ras Al Khaimah International Corporate Centre or RAK ICC),
                                    which is a Company Registry containing details of offshore companies; or overseas. The <span style={{ color: "#eab308", fontWeight: "600" }}>British Virgin Islands, Cayman Islands,</span> and <span style={{ color: "#eab308", fontWeight: "600" }}>Mauritius</span> also offer excellent venues
                                    An offshore company is a legal business that is established with the intention of operating outside its registered jurisdiction or location of ownership.
                                    In the majority of cases, offshore companies do not need to occupy physical office space, but in turn, cannot undertake extensive any business activities in the country of its origin.
                                    when <span style={{ fontWeight: 'bold' }}>setting up your offshore company.</span>
                                </p>
                            </ScrollAnimation>

                        </div>
                    </div>
                </div>
            </section>

            <section className="py-2 mt-5">
                <div className="max-w-screen-xl mx-auto px-4  gap-x-12 justify-between md:flex md:px-8">
                    <div className="max-w-xxl">
                        <p className="mt-1 text-gray-500 font-medium">
                            Offshore companies can be created and owned by individuals or institutions, and shares can be easily and freely transferred by a written instrument.
                        </p>
                        <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            <span style={{ fontWeight: 'bold' }}> Offshore company formation in Dubai </span> is a fast-growing sector of new <span style={{ color: "#eab308", fontWeight: "600" }}>business setup</span> in the country. It is typically built with provisions to minimize or eliminate taxes associated with property sales, capital gains, value-added tax (VAT), death duties, and profits on business earnings.
                        </p>
                        <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            For investors looking at offshore <span style={{ color: "#eab308", fontWeight: "600" }}>company registration in Dubai,</span>   favored considerations include the ability to create or maintain wealth, hold or protect property and other assets, and offer international trading, contracting and consulting services from a single location.
                        </p>
                        <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            <span style={{ fontWeight: 'bold' }}>Benefits of Offshore Company setup</span> in Dubai is an assurance of confidentiality over ownership and related financial affairs.
                        </p>
                        <ScrollAnimation animateIn="fadeIn">
                            <h3 className=" text-gray-600 text-3xl font-bold sm:text-3xl mt-5 pb-3">
                                Structural Benefits of Offshore Company Registration in Dubai
                            </h3>
                        </ScrollAnimation>

                        <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            When compared to many other jurisdictions, the UAE has a highly regulated banking system, sophisticated infrastructure and facilities, cutting-edge telecommunications networks, and easy access to international markets.
                        </p>
                        <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            <span style={{ fontWeight: 'bold', color: "#eab308" }}> Registering an offshore company</span> in UAE spells out several business benefits:
                        </p>
                        <div className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#FFD700" className="bi bi-check" viewBox="0 0 16 16" id="IconChangeColor">
                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" id="mainIconPathAttribute"></path>
                                </svg>
                                <p className="ml-2">Stable and business-friendly legal system</p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#FFD700" className="bi bi-check" viewBox="0 0 16 16" id="IconChangeColor">
                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" id="mainIconPathAttribute"></path>
                                </svg>
                                <p className="ml-2">Flexible regulatory regime</p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#FFD700" className="bi bi-check" viewBox="0 0 16 16" id="IconChangeColor">
                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" id="mainIconPathAttribute"></path>
                                </svg>
                                <p className="ml-2">Tax neutrality</p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#FFD700" className="bi bi-check" viewBox="0 0 16 16" id="IconChangeColor">
                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" id="mainIconPathAttribute"></path>
                                </svg>
                                <p className="ml-2">Separation and protection of assets</p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#FFD700" className="bi bi-check" viewBox="0 0 16 16" id="IconChangeColor">
                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" id="mainIconPathAttribute"></path>
                                </svg>
                                <p className="ml-2">Gateway to international markets</p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#FFD700" className="bi bi-check" viewBox="0 0 16 16" id="IconChangeColor">
                                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" id="mainIconPathAttribute"></path>
                                </svg>
                                <p className="ml-2">Access to global funding</p>
                            </div>
                        </div>
                        <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            Incorporation of offshore companies is relatively easy, quick, and simplified, and we often complete the process in a few days.
                        </p>
                        <ScrollAnimation animateIn="fadeIn">
                            <h3 className=" text-gray-600 text-3xl font-bold sm:text-3xl mt-5 pb-3">
                                Benefits of Offshore Company Registration in Dubai
                            </h3>
                        </ScrollAnimation>
                        <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            Unlike other jurisdictions which are considered solely for taxation, offshore company formation in UAE offers numerous advantages: direct investment into specific jurisdictions, better management of taxes on foreign income, full ownership of intellectual property, and the separation and protection of personal assets from operating entities.
                        </p>
                        <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                            An offshore company formation in UAE can be strategically designed to minimise overall international tax liability. There are no requirements for minimum share capital, although in some cases, the government registrar may ask that paid-up capital be commensurate with proposed activities.
                        </p>
                        <p className="mt-5 text-gray-500 font-medium mb-5" style={{ lineHeight: 2 }}>
                            Another localised advantage is related to realty. Some property developers in the UAE allow up to four owners for the purchase of a single property such as a villa, an office or an apartment. In the case of an offshore company, the number of such property owners can be extended up to 50, with ownership registered to the offshore company.
                        </p>
                    </div>
                </div>
            </section>


            <div className='container-fluid bg-img-mainland-2' style={{ marginTop: 100 }}>
                <section className="mx-auto max-w-screen-xl  px-4 items-center lg:flex md:px-8">
                    <div className="space-y-4 flex-1 sm:text-center lg:text-left">
                        <ScrollAnimation animateIn="fadeIn">
                            <h1 className="text-white font-bold text-4xl">
                                Offshore <br></br> <span style={{ color: "#eab308" }}>Company Setup</span>
                            </h1>
                        </ScrollAnimation>

                    </div>
                    <div className="flex-1 text-center  lg:mt-0 lg:ml-3" style={{ marginTop: -100 }}>
                        <img src={business_women_img} className=" mx-auto sm:w-9/12 " />
                    </div>
                </section>
            </div>

            <section className="py-2 mt-5 mb-5" style={{ marginTop: 50 }}>
                <div className="max-w-screen-xl mx-auto px-4">
                    <h3 className="text-gray-600 text-2xl font-bold sm:text-3xl pb-1">
                        Benefits of Offshore Company Formation in Dubai, UAE
                    </h3>

                    <div className='row' style={{ marginTop: 70 }}>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded"
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    Maintain confidentiality in the business dealings
                                </h3>
                            </div>
                        </div>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded mb-5"
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    Full repatriation of funds and allows multi-currency transactions
                                </h3>
                            </div>
                        </div>
                    </div>


                    <div className='row' style={{ marginTop: 20 }}>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded"
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    Exempt from annual accounting and other tax obligations
                                </h3>
                            </div>
                        </div>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded mb-5"
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    Ideal place for international trading, legally exempt from corporate tax
                                </h3>
                            </div>
                        </div>
                    </div>

                    <div className='row' style={{ marginTop: 20 }}>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded"
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    Easy to setup corporate bank account in UAE
                                </h3>
                            </div>
                        </div>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded mb-5"
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    Shareholders or directors not required to register their details and name for public record
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className='row' style={{ marginTop: 20 }}>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded"
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    Complete ownership of your company
                                </h3>
                            </div>
                        </div>
                        <div className='col'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    width={28}
                                    height={28}
                                    alt="Benefit Icon"
                                    src={tick_icon}
                                    className="lazyloaded "
                                    style={{ marginTop: -9 }}
                                    decoding="async"
                                    id="ODU0NzoyOTU=-1"
                                />
                                <h3 className="text-gray-600 text-2xl font-semibold sm:text-2xl pb-1" style={{ fontSize: 20, marginLeft: 10 }}>
                                    No trade barriers or any other foreign exchange controls
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-14 max-w-screen-xl mx-auto ">
                <div className="relative overflow-hidden mx-4 px-4 py-14 rounded-2xl bg-blue-600 md:px-8 md:mx-8 main-contact">
                    <div className="relative z-10 max-w-xxl mx-auto sm:text-center">
                        <div className="space-y-3">

                            <h3 className="text-2xl text-yellow-500 font-bold">
                                Have a question? get in touch with us
                            </h3>
                            <h3 className="text-1xl text-white font-bold" style={{ fontSize: 18 }}>
                                Get started with your business needs, we reach out with free and qualified guidance
                            </h3>
                            <h3 className="text-2xl text-white font-bold">
                                Call us today : +971 56 265 7300
                            </h3>
                        </div>
                    </div>
                    <div className="absolute inset-0 w-full h-full" style={{
                        background: "linear-gradient(268.24deg, rgba(31, 41, 55, 0.84) 50%, rgb(102, 102, 102, 0.79) 80.61%, rgba(55, 48, 163, 0) 117.35%, rgba(169, 169, 169, 0.5))"
                    }}></div>

                </div>
            </section>

            <div className=''>
                <section className="py-14">
                    <div className="max-w-screen-xl mx-auto md:px-8">
                        <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex">
                            <div className="flex-1 sm:hidden lg:block" style={{ marginBottom: 200 }}>
                                <div className="fb-iframe-container">
                                    <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fweb.facebook.com%2Fdubaisetupinfo.co&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                                        width="1240" height="500" className='fb-frame' style={{ border: 'none', overflow: 'hidden' }} scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                                </div>
                            </div>
                            <div className="max-w-xl px-4 space-y-3 mt-6 sm:px-0 md:mt-0 lg:max-w-2xl">
                                <div className="fb-container-text">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-4xl mb-5">
                                        Speed Type  <span className="text-yellow-500">Facebook Page</span>
                                    </h3>
                                    <p className="text-gray-900 text-1xl font-normal sm:text-1xl ">
                                        This company's Facebook page is a testament to their dedication to excellence, fostering a vibrant community, and showcasing their creativity. With captivating content and interactive engagement, they go beyond mere promotion, building genuine connections with their audience. Each post tells a story, evoking emotions and leaving a lasting impression on followers. Their commitment to innovation shines through in every aspect of their page, setting them apart from the competition. Moreover, they prioritize customer satisfaction, ensuring transparency and authenticity in all interactions. Their page serves as a window into their values and aspirations, inspiring trust and loyalty among their followers. Overall, this company's Facebook presence embodies their passion for making a difference and leaves a lasting impact on all who engage with it.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


        </>
    )
}
